jQuery(window).load(function () {

	// used to show the various video rooms as we scroll
	function videoRoom(pageScroll,roomID,boxPosition,videoHeight,paddingTop) {
		if(pageScroll > (boxPosition.top - videoHeight - paddingTop)) {
					var scroll = jQuery(window).scrollTop();
					// how far we have scrolled minus (the target box's original position - the video and it's padding) gives you a remainder that is the distance into the video you have gone. 
					var matrix = ((scroll - (boxPosition.top - videoHeight - paddingTop))/videoHeight); 
					var scale = (videoHeight/(scroll - (boxPosition.top - videoHeight - paddingTop)));
				   
					if (matrix < 1) {
						jQuery(roomID).css('transform','matrix(1, 0, 0, ' + matrix  + ', 0, 0)');  
						jQuery(roomID + ' video').css('transform', 'scaleY(' + scale  + ')'); 
					} else {
						jQuery(roomID).css('transform','matrix(1, 0, 0, 1, 0, 0)');  
						jQuery(roomID + ' video').css('transform', 'scaleY(1)'); 
					}
	
				}  else {
					jQuery(roomID).css('transform','matrix(1, 0, 0, 0, 0, 0)');  
					jQuery(roomID + ' video').css('transform', 'scaleY(0)'); 
				}
	} 

	// used to initially render the videos in the right size and location and use those 
	function renderPositions() {
		var height = jQuery("#room2").height();
		var viewheight = jQuery("#wrapper").height();
		
		var box2Position = jQuery('#box2').offset();
		var box3Position = jQuery('#box3').offset();
		var box4Position = jQuery('#box4').offset();
	
		var paddingTop = ((viewheight - height + 4 )/2);
	
		// The line along the story
		var lineStart = jQuery('#message').offset();
		var lineHeight = ((viewheight * 4 )+ 250);
	   
		jQuery('#line').css('height', lineHeight + 'px');
		jQuery('#line').css('top', lineStart.top + 25);
		jQuery('#line').css('display', 'block');

		jQuery('#marker-wrapper').css('top', lineStart.top + 25);
		jQuery('#marker-wrapper').css('display', 'block');
	
		var wrapperPosition = jQuery('#wrapper').offset();
	
		jQuery(window).scroll(function(){
			
				var pageScroll = jQuery(window).scrollTop();
				var room2 = videoRoom(pageScroll,'#room2',box2Position,height,paddingTop);
				var room3 = videoRoom(pageScroll,'#room3',box3Position,height,paddingTop);
				var room4 = videoRoom(pageScroll,'#room4',box4Position,height,paddingTop);
	
				//console.log(pageScroll, wrapperPosition.top);
				
				if(pageScroll > (wrapperPosition.top)) {
					jQuery("#wrapper").css('position', 'fixed'); 
				} else {
					jQuery("#wrapper").css('position', 'relative'); 
				}
	
		});
	}

	renderPositions();

	// ScrollMagic for the line and numbers as well as to make the titles appear
	var controller = new ScrollMagic.Controller(); 

	new ScrollMagic.Scene({
	triggerElement: "#line",
	offset: 0 // start this scene after scrolling xxpx
	})
	.setPin('#marker') // pins the element for the the scene's duration
	.addTo(controller); // assign the scene to the controller

	new ScrollMagic.Scene({triggerElement: "#box1 .marker-number"})
	.setClassToggle("#box1 .marker-number", "flash") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#box2 .marker-number"})
	.setClassToggle("#box2 .marker-number", "flash") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#box2 .marker-number"})
	.setClassToggle("#box2 .marker-number", "flash") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#box3 .marker-number"})
	.setClassToggle("#box3 .marker-number", "flash") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#box4 .marker-number"})
	.setClassToggle("#box4 .marker-number", "flash") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#join", offset: 150, reverse:false})
	.setClassToggle(".join", "animate__fadeInUp") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#message", offset: 0, reverse:false})
	.setClassToggle("#message span", "flow") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#message", offset: -300, reverse:false})
	.setClassToggle("#message", "animate__fadeInRight") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#actions-section", offset: -100, reverse:false })
	.setClassToggle("#actions-section h2.title", "animate__fadeInUp") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#actions-section", offset: 100, reverse:false})
	.setClassToggle("#actions-section .title span", "flow") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#sender", offset: 100})
	.setClassToggle("#title", "animate__fadeOut") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#partners-header  h2.title", offset: -200, reverse:false})
	.setClassToggle("#partners-header  h2.title", "animate__fadeInUp") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#partners-header", offset: 0, reverse:true})
	.setClassToggle("#wrapper", "hide") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#partners-header", offset: 0, reverse:true})
	.setClassToggle("#line", "hide") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#partners-header", offset: 0, reverse:true})
	.setClassToggle("#marker-wrapper", "hide") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#partners-header  h2.title", offset: 100, reverse:false})
	.setClassToggle("#partners-header  h2.title span", "flow") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#homepage-research", offset: 0, reverse:false})
	.setClassToggle("#homepage-research h2.title", "animate__fadeInUp") // add class toggle
	.addTo(controller);

	new ScrollMagic.Scene({triggerElement: "#homepage-research  h2.title", offset: 100, reverse:false})
	.setClassToggle("#homepage-research  h2.title span", "flow") // add class toggle
	.addTo(controller);
		
	// build tweens needed for the CAG scrollers to move on scroll depending on their class
	var tweenleft = TweenMax.fromTo(".scroller-left", 2,
		{left: -10},
		{left: -700, ease: Back.easeOut}, 
		0.15
	);

	var tweenright = TweenMax.fromTo(".scroller-right", 2,
		{left: -300},
		{left: -10, ease: Back.easeOut}, 
		0.15
	);

	var tweenbig = TweenMax.fromTo(".scroller-big", 2,
		{left: -100},
		{left: -300, ease: Back.easeOut}, 
		0.15
	);

	var tweenUp = TweenMax.fromTo("#signer-donate", 2,
		{marginTop: 0},
		{marginTop: -270, ease: Back.easeOut}, 
		0
	);
	// build scene
	var scene = new ScrollMagic.Scene({triggerElement: "#cag", duration: 5000, offset: -350})
					.setTween(tweenleft)
					.addTo(controller);

	var scene2 = new ScrollMagic.Scene({triggerElement: "#cag", duration: 5000, offset: -350})
					.setTween(tweenright)
					.addTo(controller);

	var scene3 = new ScrollMagic.Scene({triggerElement: "#cag", duration: 5000, offset: -450})
					.setTween(tweenbig)
					.addTo(controller);

	var scene = new ScrollMagic.Scene({triggerElement: ".video-container", duration: 0, offset: 500})
					.setTween(tweenUp)
					.addTo(controller);


	var cagIn = function() { 
		jQuery(this).animate({width: "550px"},800);
		jQuery(this).find(".black-fade").animate({height: "75%"},500);
		jQuery(this).find(".feature-excerpt").removeClass("animate__animated animate__fadeOutDown");
		jQuery(this).find(".feature-excerpt").show();
		jQuery(this).find(".feature-excerpt").addClass('animate__animated animate__fadeInUp');
	};
	var cagOut = function() { 
		jQuery(this).find(".feature-excerpt").removeClass("animate__animated animate__fadeInUp").addClass("animate__animated animate__fadeOutDown");
		jQuery(this).find(".black-fade").animate({height: "50%"},500);
		jQuery(this).animate({width: "450px"},300);
	}

	// used to determine if we need hover features on the CAG slider
	function notMobile(){
		return window.innerWidth >= 820;
	}

	if (notMobile())  {
		jQuery('#scroll3 .section').hoverIntent({
			over: cagIn,
			out: cagOut,
			sensitivity: 3,
		});
	}

	// Manual Nudge Scroll for the CAG grants
	jQuery('#scroll-left.enabled').click(function () {
		var scrollDistance = '250px';
		jQuery('#scroll3').animate({
			marginLeft: scrollDistance
		}, 500);
		jQuery('#scroll-left.enabled').toggleClass('enabled');
		jQuery('#scroll-right').addClass('enabled');
	});
	jQuery('#scroll-right.enabled').click(function () {
		var scrollDistance = '-300px';
		jQuery('#scroll3').animate({
			marginLeft: scrollDistance
		}, 500);
		jQuery('#scroll-right.enabled').toggleClass('enabled');
		jQuery('#scroll-left').addClass('enabled');
	});

	// Action Stack 

	var count = 1;
	var fadeFirst = function(howFar) {
		//return jQuery(".action.first").css({ transition: "all 1s ease", opacity: '0', transform: 'matrix(.9, 0, 0, .9, -'+howFar+', 0)'}).toggleClass("first").toggleClass("visible").delay(0);
		return jQuery(".action.first").css({ transition: "all 1s ease", transform: 'matrix(.9, 0, 0, .9, -'+howFar+', 0)'}).toggleClass("first").toggleClass("visible").delay(0);
	}

	function actionClickLeft() {
		var clickEnabled = document.querySelector('#click-left');
		var leftClick = clickEnabled.classList.contains('enabled');
		var stepDistance = (jQuery(".action.first").width() + 60);    

		if(leftClick == true) {
			count--;
			var howFar = (stepDistance * (count -1));
			// Move over the visible items
			jQuery(".action.visible").css({ transition: "transform 1s ease", transform: 'matrix(1, 0, 0, 1, -'+howFar+', 0)'});
			// toggle the first class off the last item and onto the new one.
			jQuery('.action[data-index='+(count + 1)+']').toggleClass("first");
			// Show the new item and add the first and visible tags
			//jQuery('.action[data-index='+count+']').css({ transition: "all 1s ease", opacity: '1', transform: 'matrix(1, 0, 0, 1, -'+howFar+', 0)'}).toggleClass("first").toggleClass("visible");
			jQuery('.action[data-index='+count+']').css({ transition: "all 1s ease", transform: 'matrix(1, 0, 0, 1, -'+howFar+', 0)'}).toggleClass("first").toggleClass("visible");
			// iternate the counter 
			jQuery("#click-left").attr("data-index", count);
			jQuery("#click-right").attr("data-index", count);
		}
		if(count >= 4) {
			jQuery('#click-right').addClass("enabled").removeClass("disabled");
		}
		if(count == 1) {
			jQuery('#click-left.enabled').toggleClass("enabled").toggleClass("disabled");
		}
	}
	function actionClickRight() {
		var clickEnabled = document.querySelector('#click-right');
		var rightClick = clickEnabled.classList.contains('enabled');
		var stepDistance = (jQuery(".action.first").width() + 60);
				

		if(rightClick == true) {
			count++;
			
			var howFar = (stepDistance * (count - 1));

			jQuery.when(fadeFirst(howFar - stepDistance)).done(
				function() {
					jQuery(".action.visible").css({ transition: "transform 1s", transform: 'matrix(1, 0, 0, 1, -'+howFar+', 0)'});
					jQuery('.action[data-index='+count+']').toggleClass("first");
					jQuery("#click-right").attr("data-index", count);
					jQuery("#click-left").attr("data-index", count);
				}
			)
		}    
		if(count > 1) {
			jQuery('#click-left').addClass("enabled").removeClass("disabled");
		}
		if(count == 5) {
			jQuery('#click-right.enabled').toggleClass("enabled").toggleClass("disabled");
		}
	}
	// Attach to action buttons 
	jQuery('#click-left').click(function () { 
		actionClickLeft();
	});
	jQuery('#click-right').click(function () {
		actionClickRight();
	});
	jQuery('#actions-wrapper').swiperight(function() {
		actionClickLeft();
	});
	jQuery('#actions-wrapper').swipeleft(function() {
		actionClickRight();
	});

	// Actions slideshow
	var i=0;
	//var images = [   "/wp-content/themes/ran-2023/inc/assets/images/homepage-2023/homepage-2024-action-sacraficzone.jpg, "/wp-content/themes/ran-2023/inc/assets/images/homepage-2023/homepage-2024-action-nissin.jpg","];
	var images = ["/wp-content/themes/ran-2023/inc/assets/images/homepage-2023/homepage-2024-action-pg-g-bridge.jpg", "/wp-content/themes/ran-2023/inc/assets/images/homepage-2023/homepage-2023-action-chase-action.jpg", "/wp-content/themes/ran-2023/inc/assets/images/homepage-2023/homepage-2023-action-north-sumatra-women-deforestation.jpg", "/wp-content/themes/ran-2023/inc/assets/images/homepage-2023/homepage-2024-action-chubb.jpg", "/wp-content/themes/ran-2023/inc/assets/images/homepage-2023/homepage-2023-action-deforestation-mondelez.jpg", "/wp-content/themes/ran-2023/inc/assets/images/homepage-2023/homepage-2023-action-black-rock.jpg", "/wp-content/themes/ran-2023/inc/assets/images/homepage-2023/homepage-2023-action-mufg.jpg","/wp-content/themes/ran-2023/inc/assets/images/homepage-2023/homepage-2023-action-insurance.jpg" ];
	function slideimg() {
		setTimeout(function () {
			jQuery('.action-image').css('background-image', 'url('+images[i]+')');
			i++;
			if(i==images.length) i=0;
			slideimg();
		}, 7000);
	}
	slideimg();

	jQuery("#partner-quotes").slick({
		arrows: true,
		infinite: false,
		dots: false,
		speed: 100,
		slidesToShow: 1,
		adaptiveHeight: true,
		autoplay: true,
		accessibility: false,
		autoplaySpeed: 6000, 
		speed: 1000,
		pauseOnHover: false,
		prevArrow: jQuery('.prev'),
		nextArrow: jQuery('.next')
	});	

	jQuery('.slick-arrow').on('click', function() {
		jQuery('#partner-quotes').slick('slickPause');
	});
	
	jQuery(window).on('resize', function(){
			//location.reload();
			jQuery("#wrapper").css('position', 'relative'); 
			renderPositions();
	});

});

jQuery( document ).ready(function() {
	var myform = document.getElementById('nb-signup');
	myform.onsubmit = function(){
		var email = document.getElementById('signup_email').value;
		console.log(email);
		var split = email.split('@')
		var split = email.replace('@', '*');
		console.log(split);
		document.getElementById('signup_email').value = split;
		myform.submit();
	};
});
